/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ParcelaPaginado } from '../models/parcela-paginado';
import { ProcedenciaAcordo } from '../models/procedencia-acordo';
import { ProcedenciaAcordoPaginado } from '../models/procedencia-acordo-paginado';
import { TipoOrigemAcordo } from '../models/tipo-origem-acordo';
import { TipoOrigemAcordoPaginado } from '../models/tipo-origem-acordo-paginado';
import { TipoParcela } from '../models/tipo-parcela';
import { TipoParcelaPaginado } from '../models/tipo-parcela-paginado';
import { TipoRecebimento } from '../models/tipo-recebimento';
import { TipoRecebimentoPaginado } from '../models/tipo-recebimento-paginado';
import { TipoEnvioBoleto } from '../models/tipo-envio-boleto';
import { TipoEnvioBoletoPaginado } from '../models/tipo-envio-boleto-paginado';
import { SituacaoAcordo } from '../models/situacao-acordo';
import { TipoSituacaoParcelaAcordoPaginado } from '../models/tipo-situacao-parcela-acordo-paginado';
import { SituacaoLote } from '../models/situacao-lote';
import { StatusLinhaCredito } from '../models/status-linha-credito';
import { StatusTransacaoCredito } from '../models/status-transacao-credito';
import { FormaPagamento } from '../models/forma-pagamento';
import { CategoriaDevedor } from '../models/categoria-devedor';
import { Message } from '../models/message';
import { Dinamica } from '../models/dinamica';

/**
 * Dominios da aplicacao, contem os cadastros de procedencia de acordo, tipos de origem de acordo, tipo parcela acordo, tipo recebimento acordo, tipo envio boleto
 */
@Injectable({
  providedIn: 'root',
})
class DominiosService extends __BaseService {
  static readonly obterParcelasAcordoPaginadoPath = '/parcelas/paged';
  static readonly obterProcedenciasAcordoPath = '/procedencias';
  static readonly obterProcedenciasAcordoPorRamoPath = '/procedencias/{codigoRamo}';
  static readonly obterProcedenciaAcordoPaginadoPath = '/procedencias/paged';
  static readonly obterTiposOrigemAcordoPath = '/tipos-origem';
  static readonly obterTiposOrigemAcordoPorRamoPath = '/tipos-origem/{codigoRamo}';
  static readonly obterTiposOrigemAcordoPaginadoPath = '/tipos-origem/paged';
  static readonly obterTiposParcelaPath = '/tipos-parcela';
  static readonly obterTiposParcelaPaginadoPath = '/tipos-parcela/paged';
  static readonly obterTiposRecebimentoPath = '/tipos-recebimento';
  static readonly obterTiposRecebimentoPorRamoPath = '/tipos-recebimento/{codigoRamo}';
  static readonly obterTiposRecebimentoPaginadoPath = '/tipos-recebimento/paged';
  static readonly obterTiposEnvioBoletoPath = '/tipos-envio-boleto';
  static readonly obterTiposEnvioBoletoPaginadoPath = '/tipos-envio-boleto/paged';
  static readonly obterTiposSituacaoAcordoPath = '/tipos-situacao-acordo';
  static readonly obterSituacaoParcelaAcordoPath = '/tipos-situacao-parcela';
  static readonly obterobterSituacaoParcelaAcordoPaginadoPath = '/tipos-situacao-parcela-acordo/paged';
  static readonly obterSituacaoLotePath = '/tipos-situacao-lote';
  static readonly obterSituacoesExtratoPath = '/tipos-situacao-linha-extrato';
  static readonly obterSituacaoTransacaoCreditoPath = '/tipos-situacao-transacao-credito';
  static readonly obterFormasPagamentoPath = '/formas-pagamento';
  static readonly obterAllListaCategoriaDevedorPath = '/categoria-devedor/todos';
  static readonly obterListaCategoriaDevedorPath = '/categoria-devedor';
  static readonly alterarCategoriaDevedorPath = '/categoria-devedor';
  static readonly salvarCategoriaDevedorPath = '/categoria-devedor';
  static readonly obterListaDinamicasJuridicoPath = '/dinamicas';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Recupera os registros de forma paginada do cadastro de parcelas
   * @return Operacao realizada com sucesso
   */
  obterParcelasAcordoPaginadoResponse(): __Observable<__StrictHttpResponse<ParcelaPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/parcelas/paged`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ParcelaPaginado>;
      })
    );
  }
  /**
   * Recupera os registros de forma paginada do cadastro de parcelas
   * @return Operacao realizada com sucesso
   */
  obterParcelasAcordoPaginado(): __Observable<ParcelaPaginado> {
    return this.obterParcelasAcordoPaginadoResponse().pipe(
      __map(_r => _r.body as ParcelaPaginado)
    );
  }

  /**
   * Recupera todos os registros do cadastro de procedencias de acordo
   * @return Operacao realizada com sucesso
   */
  obterProcedenciasAcordoResponse(): __Observable<__StrictHttpResponse<Array<ProcedenciaAcordo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/procedencias`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ProcedenciaAcordo>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de procedencias de acordo
   * @return Operacao realizada com sucesso
   */
  obterProcedenciasAcordo(): __Observable<Array<ProcedenciaAcordo>> {
    return this.obterProcedenciasAcordoResponse().pipe(
      __map(_r => _r.body as Array<ProcedenciaAcordo>)
    );
  }

  /**
   * Recupera todos os registros do cadastro de procedencias de acordo por codigo ramo
   * @param codigoRamo Codigo identificador do ramo
   * @return Operacao realizada com sucesso
   */
  obterProcedenciasAcordoPorRamoResponse(codigoRamo: number): __Observable<__StrictHttpResponse<Array<ProcedenciaAcordo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/procedencias/${encodeURIComponent(String(codigoRamo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ProcedenciaAcordo>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de procedencias de acordo por codigo ramo
   * @param codigoRamo Codigo identificador do ramo
   * @return Operacao realizada com sucesso
   */
  obterProcedenciasAcordoPorRamo(codigoRamo: number): __Observable<Array<ProcedenciaAcordo>> {
    return this.obterProcedenciasAcordoPorRamoResponse(codigoRamo).pipe(
      __map(_r => _r.body as Array<ProcedenciaAcordo>)
    );
  }

  /**
   * Recupera os registros de forma paginada do cadastro de procedencias de acordo
   * @return Operacao realizada com sucesso
   */
  obterProcedenciaAcordoPaginadoResponse(): __Observable<__StrictHttpResponse<ProcedenciaAcordoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/procedencias/paged`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ProcedenciaAcordoPaginado>;
      })
    );
  }
  /**
   * Recupera os registros de forma paginada do cadastro de procedencias de acordo
   * @return Operacao realizada com sucesso
   */
  obterProcedenciaAcordoPaginado(): __Observable<ProcedenciaAcordoPaginado> {
    return this.obterProcedenciaAcordoPaginadoResponse().pipe(
      __map(_r => _r.body as ProcedenciaAcordoPaginado)
    );
  }

  /**
   * Recupera todos os registros do cadastro de tipos de origem de acordo
   * @return Operacao realizada com sucesso
   */
  obterTiposOrigemAcordoResponse(): __Observable<__StrictHttpResponse<Array<TipoOrigemAcordo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-origem`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TipoOrigemAcordo>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de tipos de origem de acordo
   * @return Operacao realizada com sucesso
   */
  obterTiposOrigemAcordo(): __Observable<Array<TipoOrigemAcordo>> {
    return this.obterTiposOrigemAcordoResponse().pipe(
      __map(_r => _r.body as Array<TipoOrigemAcordo>)
    );
  }

  /**
   * Recupera todos os registros do cadastro de tipos de origem de acordo por codigo ramo
   * @param codigoRamo Codigo identificador do ramo
   * @return Operacao realizada com sucesso
   */
  obterTiposOrigemAcordoPorRamoResponse(codigoRamo: number): __Observable<__StrictHttpResponse<Array<TipoOrigemAcordo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-origem/${encodeURIComponent(String(codigoRamo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TipoOrigemAcordo>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de tipos de origem de acordo por codigo ramo
   * @param codigoRamo Codigo identificador do ramo
   * @return Operacao realizada com sucesso
   */
  obterTiposOrigemAcordoPorRamo(codigoRamo: number): __Observable<Array<TipoOrigemAcordo>> {
    return this.obterTiposOrigemAcordoPorRamoResponse(codigoRamo).pipe(
      __map(_r => _r.body as Array<TipoOrigemAcordo>)
    );
  }

  /**
   * Recupera os registros de forma paginada do cadastro de tipos de origem de acordo
   * @return Operacao realizada com sucesso
   */
  obterTiposOrigemAcordoPaginadoResponse(): __Observable<__StrictHttpResponse<TipoOrigemAcordoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-origem/paged`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TipoOrigemAcordoPaginado>;
      })
    );
  }
  /**
   * Recupera os registros de forma paginada do cadastro de tipos de origem de acordo
   * @return Operacao realizada com sucesso
   */
  obterTiposOrigemAcordoPaginado(): __Observable<TipoOrigemAcordoPaginado> {
    return this.obterTiposOrigemAcordoPaginadoResponse().pipe(
      __map(_r => _r.body as TipoOrigemAcordoPaginado)
    );
  }

  /**
   * Recupera todos os registros do cadastro de tipos de parcela
   * @return Operacao realizada com sucesso
   */
  obterTiposParcelaResponse(): __Observable<__StrictHttpResponse<Array<TipoParcela>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-parcela`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TipoParcela>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de tipos de parcela
   * @return Operacao realizada com sucesso
   */
  obterTiposParcela(): __Observable<Array<TipoParcela>> {
    return this.obterTiposParcelaResponse().pipe(
      __map(_r => _r.body as Array<TipoParcela>)
    );
  }

  /**
   * Recupera os registros de forma paginada do cadastro de tipos de parcela
   * @return Operacao realizada com sucesso
   */
  obterTiposParcelaPaginadoResponse(): __Observable<__StrictHttpResponse<TipoParcelaPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-parcela/paged`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TipoParcelaPaginado>;
      })
    );
  }
  /**
   * Recupera os registros de forma paginada do cadastro de tipos de parcela
   * @return Operacao realizada com sucesso
   */
  obterTiposParcelaPaginado(): __Observable<TipoParcelaPaginado> {
    return this.obterTiposParcelaPaginadoResponse().pipe(
      __map(_r => _r.body as TipoParcelaPaginado)
    );
  }

  /**
   * Recupera todos os registros do cadastro de tipos de recebimento para os acordos
   * @return Operacao realizada com sucesso
   */
  obterTiposRecebimentoResponse(): __Observable<__StrictHttpResponse<Array<TipoRecebimento>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-recebimento`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TipoRecebimento>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de tipos de recebimento para os acordos
   * @return Operacao realizada com sucesso
   */
  obterTiposRecebimento(): __Observable<Array<TipoRecebimento>> {
    return this.obterTiposRecebimentoResponse().pipe(
      __map(_r => _r.body as Array<TipoRecebimento>)
    );
  }

  /**
   * Recupera todos os registros do cadastro de tipos de recebimento para os acordos por codigo ramo
   * @param params The `DominiosService.ObterTiposRecebimentoPorRamoParams` containing the following parameters:
   *
   * - `codigoRamo`: Codigo identificador do ramo
   *
   * - `origemAcessoWorkflow`: Identifica se o acesso ao servico parte de uma requisicao iniciado a partir do workflow legado
   *
   * @return Operacao realizada com sucesso
   */
  obterTiposRecebimentoPorRamoResponse(params: DominiosService.ObterTiposRecebimentoPorRamoParams): __Observable<__StrictHttpResponse<Array<TipoRecebimento>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.origemAcessoWorkflow != null) __params = __params.set('origemAcessoWorkflow', params.origemAcessoWorkflow.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-recebimento/${encodeURIComponent(String(params.codigoRamo))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TipoRecebimento>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de tipos de recebimento para os acordos por codigo ramo
   * @param params The `DominiosService.ObterTiposRecebimentoPorRamoParams` containing the following parameters:
   *
   * - `codigoRamo`: Codigo identificador do ramo
   *
   * - `origemAcessoWorkflow`: Identifica se o acesso ao servico parte de uma requisicao iniciado a partir do workflow legado
   *
   * @return Operacao realizada com sucesso
   */
  obterTiposRecebimentoPorRamo(params: DominiosService.ObterTiposRecebimentoPorRamoParams): __Observable<Array<TipoRecebimento>> {
    return this.obterTiposRecebimentoPorRamoResponse(params).pipe(
      __map(_r => _r.body as Array<TipoRecebimento>)
    );
  }

  /**
   * Recupera os registros de forma paginada do cadastro de tipos de recebimento para os acordos
   * @return Operacao realizada com sucesso
   */
  obterTiposRecebimentoPaginadoResponse(): __Observable<__StrictHttpResponse<TipoRecebimentoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-recebimento/paged`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TipoRecebimentoPaginado>;
      })
    );
  }
  /**
   * Recupera os registros de forma paginada do cadastro de tipos de recebimento para os acordos
   * @return Operacao realizada com sucesso
   */
  obterTiposRecebimentoPaginado(): __Observable<TipoRecebimentoPaginado> {
    return this.obterTiposRecebimentoPaginadoResponse().pipe(
      __map(_r => _r.body as TipoRecebimentoPaginado)
    );
  }

  /**
   * Recupera todos os registros do cadastro de tipos de envio de boletos
   * @return Operacao realizada com sucesso
   */
  obterTiposEnvioBoletoResponse(): __Observable<__StrictHttpResponse<Array<TipoEnvioBoleto>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-envio-boleto`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TipoEnvioBoleto>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de tipos de envio de boletos
   * @return Operacao realizada com sucesso
   */
  obterTiposEnvioBoleto(): __Observable<Array<TipoEnvioBoleto>> {
    return this.obterTiposEnvioBoletoResponse().pipe(
      __map(_r => _r.body as Array<TipoEnvioBoleto>)
    );
  }

  /**
   * Recupera os registros de forma paginada do cadastro de tipos de envio de boletos
   * @return Operacao realizada com sucesso
   */
  obterTiposEnvioBoletoPaginadoResponse(): __Observable<__StrictHttpResponse<TipoEnvioBoletoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-envio-boleto/paged`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TipoEnvioBoletoPaginado>;
      })
    );
  }
  /**
   * Recupera os registros de forma paginada do cadastro de tipos de envio de boletos
   * @return Operacao realizada com sucesso
   */
  obterTiposEnvioBoletoPaginado(): __Observable<TipoEnvioBoletoPaginado> {
    return this.obterTiposEnvioBoletoPaginadoResponse().pipe(
      __map(_r => _r.body as TipoEnvioBoletoPaginado)
    );
  }

  /**
   * Recupera todos os registros do cadastro de situacoes do acordo ou proposta
   * @return Operacao realizada com sucesso
   */
  obterTiposSituacaoAcordoResponse(): __Observable<__StrictHttpResponse<Array<SituacaoAcordo>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-situacao-acordo`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SituacaoAcordo>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de situacoes do acordo ou proposta
   * @return Operacao realizada com sucesso
   */
  obterTiposSituacaoAcordo(): __Observable<Array<SituacaoAcordo>> {
    return this.obterTiposSituacaoAcordoResponse().pipe(
      __map(_r => _r.body as Array<SituacaoAcordo>)
    );
  }

  /**
   * Recupera todos os registros do cadastro de situacoes de parcela
   * @return Operacao realizada com sucesso
   */
  obterSituacaoParcelaAcordoResponse(): __Observable<__StrictHttpResponse<Array<TipoSituacaoParcelaAcordoPaginado>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-situacao-parcela`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TipoSituacaoParcelaAcordoPaginado>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de situacoes de parcela
   * @return Operacao realizada com sucesso
   */
  obterSituacaoParcelaAcordo(): __Observable<Array<TipoSituacaoParcelaAcordoPaginado>> {
    return this.obterSituacaoParcelaAcordoResponse().pipe(
      __map(_r => _r.body as Array<TipoSituacaoParcelaAcordoPaginado>)
    );
  }

  /**
   * Recupera os registros de forma paginada do cadastro de situacoes da parcela
   * @return Operacao realizada com sucesso
   */
  obterobterSituacaoParcelaAcordoPaginadoResponse(): __Observable<__StrictHttpResponse<TipoEnvioBoletoPaginado>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-situacao-parcela-acordo/paged`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<TipoEnvioBoletoPaginado>;
      })
    );
  }
  /**
   * Recupera os registros de forma paginada do cadastro de situacoes da parcela
   * @return Operacao realizada com sucesso
   */
  obterobterSituacaoParcelaAcordoPaginado(): __Observable<TipoEnvioBoletoPaginado> {
    return this.obterobterSituacaoParcelaAcordoPaginadoResponse().pipe(
      __map(_r => _r.body as TipoEnvioBoletoPaginado)
    );
  }

  /**
   * Recupera todos os registros do cadastro de situacoes de parcela
   * @return Operacao realizada com sucesso
   */
  obterSituacaoLoteResponse(): __Observable<__StrictHttpResponse<Array<SituacaoLote>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-situacao-lote`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SituacaoLote>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de situacoes de parcela
   * @return Operacao realizada com sucesso
   */
  obterSituacaoLote(): __Observable<Array<SituacaoLote>> {
    return this.obterSituacaoLoteResponse().pipe(
      __map(_r => _r.body as Array<SituacaoLote>)
    );
  }

  /**
   * Recupera todos os tipos de situacao de linha de extrato
   * @return Operacao realizada com sucesso
   */
  obterSituacoesExtratoResponse(): __Observable<__StrictHttpResponse<Array<StatusLinhaCredito>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-situacao-linha-extrato`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<StatusLinhaCredito>>;
      })
    );
  }
  /**
   * Recupera todos os tipos de situacao de linha de extrato
   * @return Operacao realizada com sucesso
   */
  obterSituacoesExtrato(): __Observable<Array<StatusLinhaCredito>> {
    return this.obterSituacoesExtratoResponse().pipe(
      __map(_r => _r.body as Array<StatusLinhaCredito>)
    );
  }

  /**
   * Recupera todos os registros do cadastro de situacoes de transações
   * @return Operacao realizada com sucesso
   */
  obterSituacaoTransacaoCreditoResponse(): __Observable<__StrictHttpResponse<Array<StatusTransacaoCredito>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/tipos-situacao-transacao-credito`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<StatusTransacaoCredito>>;
      })
    );
  }
  /**
   * Recupera todos os registros do cadastro de situacoes de transações
   * @return Operacao realizada com sucesso
   */
  obterSituacaoTransacaoCredito(): __Observable<Array<StatusTransacaoCredito>> {
    return this.obterSituacaoTransacaoCreditoResponse().pipe(
      __map(_r => _r.body as Array<StatusTransacaoCredito>)
    );
  }

  /**
   * Recupera todos os registros do enum de forma de pagamento
   * @return Operacao realizada com sucesso
   */
  obterFormasPagamentoResponse(): __Observable<__StrictHttpResponse<Array<FormaPagamento>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/formas-pagamento`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<FormaPagamento>>;
      })
    );
  }
  /**
   * Recupera todos os registros do enum de forma de pagamento
   * @return Operacao realizada com sucesso
   */
  obterFormasPagamento(): __Observable<Array<FormaPagamento>> {
    return this.obterFormasPagamentoResponse().pipe(
      __map(_r => _r.body as Array<FormaPagamento>)
    );
  }

  /**
   * Recupera toda lista de categoria do devedor
   * @return Operacao realizada com sucesso
   */
  obterAllListaCategoriaDevedorResponse(): __Observable<__StrictHttpResponse<Array<CategoriaDevedor>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/categoria-devedor/todos`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CategoriaDevedor>>;
      })
    );
  }
  /**
   * Recupera toda lista de categoria do devedor
   * @return Operacao realizada com sucesso
   */
  obterAllListaCategoriaDevedor(): __Observable<Array<CategoriaDevedor>> {
    return this.obterAllListaCategoriaDevedorResponse().pipe(
      __map(_r => _r.body as Array<CategoriaDevedor>)
    );
  }

  /**
   * Recupera toda lista de categoria do devedor
   * @return Operacao realizada com sucesso
   */
  obterListaCategoriaDevedorResponse(): __Observable<__StrictHttpResponse<Array<CategoriaDevedor>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/categoria-devedor`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CategoriaDevedor>>;
      })
    );
  }
  /**
   * Recupera toda lista de categoria do devedor
   * @return Operacao realizada com sucesso
   */
  obterListaCategoriaDevedor(): __Observable<Array<CategoriaDevedor>> {
    return this.obterListaCategoriaDevedorResponse().pipe(
      __map(_r => _r.body as Array<CategoriaDevedor>)
    );
  }

  /**
   * Altera CategoriaDevedor
   * @param categoriaDevedor Objeto do CategoriaDevedor
   * @return Operacao realizada com sucesso
   */
  alterarCategoriaDevedorResponse(categoriaDevedor: CategoriaDevedor): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = categoriaDevedor;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/categoria-devedor`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Altera CategoriaDevedor
   * @param categoriaDevedor Objeto do CategoriaDevedor
   * @return Operacao realizada com sucesso
   */
  alterarCategoriaDevedor(categoriaDevedor: CategoriaDevedor): __Observable<Message> {
    return this.alterarCategoriaDevedorResponse(categoriaDevedor).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Cadastra uma CategoriaDevedor
   * @param categoriaDevedor Objeto do CategoriaDevedor
   * @return Operacao realizada com sucesso
   */
  salvarCategoriaDevedorResponse(categoriaDevedor: CategoriaDevedor): __Observable<__StrictHttpResponse<Message>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = categoriaDevedor;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/categoria-devedor`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Message>;
      })
    );
  }
  /**
   * Cadastra uma CategoriaDevedor
   * @param categoriaDevedor Objeto do CategoriaDevedor
   * @return Operacao realizada com sucesso
   */
  salvarCategoriaDevedor(categoriaDevedor: CategoriaDevedor): __Observable<Message> {
    return this.salvarCategoriaDevedorResponse(categoriaDevedor).pipe(
      __map(_r => _r.body as Message)
    );
  }

  /**
   * Recupera toda lista de dinamicas do Legado Juridico
   * @return Operacao realizada com sucesso
   */
  obterListaDinamicasJuridicoResponse(): __Observable<__StrictHttpResponse<Array<Dinamica>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/dinamicas`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<Dinamica>>;
      })
    );
  }
  /**
   * Recupera toda lista de dinamicas do Legado Juridico
   * @return Operacao realizada com sucesso
   */
  obterListaDinamicasJuridico(): __Observable<Array<Dinamica>> {
    return this.obterListaDinamicasJuridicoResponse().pipe(
      __map(_r => _r.body as Array<Dinamica>)
    );
  }
}

module DominiosService {

  /**
   * Parameters for obterTiposRecebimentoPorRamo
   */
  export interface ObterTiposRecebimentoPorRamoParams {

    /**
     * Codigo identificador do ramo
     */
    codigoRamo: number;

    /**
     * Identifica se o acesso ao servico parte de uma requisicao iniciado a partir do workflow legado
     */
    origemAcessoWorkflow?: boolean;
  }
}

export { DominiosService }
